import React from 'react'

const Loader = props => (
  <div className={props.loader ? "loader-box block" : "loader-box"}>
    <div className="loader" />
  </div>    
)

export default Loader;